import React, { useEffect, useState } from 'react'
import withRouter from "components/Common/withRouter";
import PropTypes from "prop-types";
import { Col, Container, Row } from 'reactstrap';
import { useSearchParams } from 'react-router-dom';
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Card from 'components/PurpleTheme/Card';
import AlertList from "../AlertLog/AlertList";
import AlertAnalytics from "../AlertAnalytics/AlertAnalytics";
import SideBar from "../../components/HorizontalLayout/Sidebar";
import AlertsForOptimization from "../AlertsForOpitmization/AlertForOptimization";
import MttrMtta from "../MTTR MTTA Dashboard/MttrMtta";
import "./style.scss"

const Alerts = props => {
    const [searchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState('AlertsList');

    useEffect(() => {
        const tab = searchParams.get('tab');
        if (tab) {
            setActiveTab(tab);
        }
    }, [searchParams]);

    return (
        <React.Fragment>
            <div className="d-flex gap-2">
                <SideBar current_page='AlertList' />
                <div className="custom-style" style={{width:'90%',marginLeft: '13%'}}>
                    <div className="page-content pt-0 pt-md-4">
                        <Container fluid>
                            <Row>
                                <Col lg="8">
                                    <Breadcrumbs
                                        title={activeTab === 'AlertsList' ? "Alert List" :
                                          activeTab === 'AlertAnalytics' ?"Alert Analytics" :
                                            activeTab === 'AlertsForOptimization' ? 'Alert Optimization' :
                                              "MTTR MTTA"}
                                        breadcrumbItem={activeTab === 'AlertsList' ? "Alert List" :
                                          activeTab === 'AlertAnalytics' ?"Alert Analytics" :
                                            activeTab === 'AlertsForOptimization' ? 'Alert Optimization' :
                                              "MTTR MTTA"}
                                    />
                                </Col>
                            </Row>
                            <div className="w-100">
                                {activeTab === 'AlertsList' ?
                                    <Card>
                                        <AlertList/>
                                    </Card>
                                    :
                                    activeTab === 'AlertAnalytics' ?
                                        <AlertAnalytics/>
                                    :
                                      activeTab === 'AlertsForOptimization'?
                                        <AlertsForOptimization />
                                        :
                                        <div className="w-100 d-flex justify-content-center"><MttrMtta/></div>
                                }
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

Alerts.propTypes = {
    t: PropTypes.any,
};

export default withRouter(Alerts);